const getErrorMessage = (e) => {
    if (!e) return;

    return `${e}${e.code !== undefined ? ', code: ' + e.code : ''}`;
};

export default {
    getErrorMessage,
};
